import { render } from "./ProjectionCreationForm.vue?vue&type=template&id=526d0fc7"
import script from "./ProjectionCreationForm.vue?vue&type=script&lang=js"
export * from "./ProjectionCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__